import React, { useCallback, useEffect, useState } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { Dropdown } from "react-bootstrap";
import { addDays } from "date-fns";
import {
  getContainerStandingData,
  getDashboardData,
  getFillRateData,
  getPodStandingData,
  getAllSitesData,
} from "../../../app/pages/redux/commonAction";
import { fetchPermission } from "../../../app/pages/redux/permission";
import { format } from "date-fns";
import { dealsFranchiseListing } from "../../../app/modules/ContactDeals/_redux/deals/dealsCrud";
import { InputGroup } from "react-bootstrap";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import DatePicker from "react-datepicker";
import moment from "moment";
import { LoadingCustome } from "../controls/LoadingCustome";
import RefreshIcon from "@mui/icons-material/Refresh";
import { fetchStats } from "../../../app/modules/Order/_redux/order/orderAction";
import withStyles from '@mui/styles/withStyles';
import makeStyles from '@mui/styles/makeStyles';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import { getContainerBarSegments } from "../../../app/utils/containerBarSegments";

const StyledTableCell = withStyles((theme) => ({
  head: {
    color: "#d35401",
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.action.hover,
    },
  },
}))(TableRow);
const useStyles = makeStyles((theme) => ({
  table: {
    minWidth: 700,
  },
  refreshIcon: {
    transition: "transform 0.3s linear",
    animation: "$rotate 1s linear infinite",
  },
  "@keyframes rotate": {
    "0%": {
      transform: "rotate(0deg)",
    },
    "100%": {
      transform: "rotate(360deg)",
    },
  },
}));
/**
 * Main dashboard view with franchise metrics, standings, and container site charts.
 *
 * @returns {JSX.Element}
 */
export function DashboardComponent() {
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.auth);

  const TOTAL_BAR_WIDTH = 1200; // Fixed width for bars

  const {
    feedsData,
    permission,
    dashboardState,
    role,
    userData,
    admin,
    loading,
    dashboardPod,
    dashboardContainer,
    adminR,
    loadingPod,
    loadingContainer,
    dashboardFillRateState,
    dashboardConListState,
  } = useSelector(
    (state) => ({
      feedsData: state.common.dashboardFeeds,
      dashboardState: state.common.dashboardDataState,
      dashboardPod: state.common.dashboardPodDataState?.podStandings,
      dashboardContainer:
        state.common.dashboardContainerDataState?.podStandings,
      permission: state.auth.permission,
      role: state.auth.user.roles,
      userData: state.auth.user,
      admin: state.auth,
      loading: state.common.loading,
      loadingPod: state.common.loadingPod,
      loadingContainer: state.common.loadingContainer,
      adminR: state.auth.user,
      dashboardFillRateState: state.common.dashboardFillRateState,
      dashboardConListState: state.common.dashboardConSiteListState,
    }),
    shallowEqual
  );

  const classes = useStyles();

  const [date, setDate] = useState([
    {
      startDate: new Date(),
      endDate: addDays(new Date(), 7),
      key: "selection",
    },
  ]);

  const [dateText, setDateText] = useState("");
  const [filter, setFilter] = useState({
    franchise_id: [],
    start_date: "",
    end_date: "",
  });
  const [filterPod, setFilterPod] = useState({
    franchise_id: [],
    start_date: "",
    end_date: "",
  });
  const [filterContainer, setFilterContainer] = useState({
    franchise_id: [],
    start_date: "",
    end_date: "",
  });
  const [filterFillRate, setFilterFillRate] = useState({
    franchise_id: [],
    start_date: "",
    end_date: "",
  });
  const [franchises, setFranchise] = useState([]);
  const handleFranchiseList = () => {
    dealsFranchiseListing().then((res) => {
      setFranchise(res.data.data);
    });
  };

  const handleRefreshClick = () => {
    dispatch(fetchStats());
    // setRotating(true);
  };

  useEffect(() => {
    const timeout = setTimeout(() => {
      handleFranchiseList();
    }, 1000);

    return () => {
      clearTimeout(timeout);
    };
  }, []);

  const handleDate = useCallback(() => {
    if (new Date(date[0].startDate).getDate() === new Date().getDate()) {
      setDateText("Today");
    } else if (
      new Date(date[0].startDate).getDate() ===
      new Date().getDate() - 1
    ) {
      setDateText("Yesteday");
    } else if (
      new Date(date[0].startDate).getDate() <
      new Date(date[0].endDate).getDate()
    ) {
      let start = format(new Date(date[0].startDate), "MMMM dd");
      let end = format(new Date(date[0].endDate), "MMMM dd");
      setDateText(`${start} to ${end}`);
    } else {
      let start = format(new Date(date[0].startDate), "MMMM dd");
      let end = format(new Date(date[0].endDate), "MMMM dd");
      setDateText(`${start} to ${end}`);
    }
  }, [date]);

  useEffect(() => {
    handleDate();
  }, [handleDate]);

  const { statsData } = useSelector(
    (state) => ({
      statsData: state.order.statsData,
    }),
    shallowEqual
  );

  const formatKey = (key) => {
    if (key === undefined) return "";
    // return key
    const formattedKey = key.replace(/_/g, " ").toLowerCase();
    return formattedKey.charAt(0).toUpperCase() + formattedKey.slice(1);
  };
  useEffect(() => {
    if (role && role?.length && role[0]?.name === "franchise-owner") {
      const arr = [];
      arr.push(userData?.franchise_id);
      setFilter({
        ...filter,
        franchise_id: arr,
      });
      setFilterPod({
        ...filter,
        franchise_id: arr,
      });
      setFilterContainer({
        ...filter,
        franchise_id: arr,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [role]);

  useEffect(() => {
    if (role && role?.length && role[0] === "super-admin" || role[0] === "visitor" ) {
      dispatch(fetchStats());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  useEffect(() => {
    // dispatch(fetchDashboardFeed());
    if (
      (userData?.roles?.length > 0 &&
        userData.roles[0] !== "super-admin" &&
        filter?.franchise_id?.length > 0) ||
      (userData?.roles?.length > 0 && userData.roles[0] == "super-admin") ||
      (userData?.roles?.length > 0 && userData.roles[0] == "visitor") ||
      (userData?.roles?.length > 0 && userData.roles[0] == "super-agent") ||
      (userData?.roles?.length > 0 && userData.roles[0] == "franchise-owner")
    ) {
      if (
        (filter.start_date && filter.end_date) ||
        (filter.start_date == "" && filter.end_date == "")
      ) {
        dispatch(
          getDashboardData(
            filter,
            userData.roles[0] == "franchise-owner" ? userData?.franchise_id : ""
          )
        );
      }
    }
    // dispatch(fetchPermission());
  }, [filter]);
  useEffect(() => {
    // dispatch(fetchDashboardFeed());
    console.log("userData", userData);

    if (
      (userData?.roles?.length > 0 &&
        userData.roles[0] !== "super-admin" &&
        filterPod?.franchise_id?.length > 0) ||
      (userData?.roles?.length > 0 && userData.roles[0] == "super-admin") ||
      (userData?.roles?.length > 0 && userData.roles[0] == "visitor") ||
      (userData?.roles?.length > 0 && userData.roles[0] == "super-agent") ||
      (userData?.roles?.length > 0 && userData.roles[0] == "franchise-owner")
    ) {
      if (
        (filterPod.start_date && filterPod.end_date) ||
        (filterPod.start_date == "" && filterPod.end_date == "")
      ) {
        dispatch(
          getPodStandingData(
            filterPod,
            userData.roles[0] == "franchise-owner" ? userData?.franchise_id : ""
          )
        );
      }
    }
    // dispatch(fetchPermission());
  }, [filterPod]);

  useEffect(() => {
    // dispatch(fetchDashboardFeed());
    if (
      (userData?.roles?.length > 0 &&
        userData.roles[0] !== "super-admin" &&
        filterContainer?.franchise_id?.length > 0) ||
      (userData?.roles?.length > 0 && userData.roles[0] == "super-admin") ||
      (userData?.roles?.length > 0 && userData.roles[0] == "visitor") ||
      (userData?.roles?.length > 0 && userData.roles[0] == "super-agent") ||
      (userData?.roles?.length > 0 && userData.roles[0] == "franchise-owner")
    ) {
      if (
        (filterContainer.start_date && filterContainer.end_date) ||
        (filterContainer.start_date == "" && filterContainer.end_date == "")
      ) {
        dispatch(
          getContainerStandingData(
            filterContainer,
            userData.roles[0] == "franchise-owner" ? userData?.franchise_id : ""
          )
        );
      }
    }
    // dispatch(fetchPermission());
  }, [filterContainer]);

  useEffect(() => {
    // dispatch(fetchDashboardFeed());
    if (
      (userData?.roles?.length > 0 &&
        userData.roles[0] !== "super-admin" &&
        filterContainer?.franchise_id?.length > 0) ||
      (userData?.roles?.length > 0 && userData.roles[0] == "super-admin") ||
      (userData?.roles?.length > 0 && userData.roles[0] == "visitor") ||
      (userData?.roles?.length > 0 && userData.roles[0] == "super-agent") ||
      (userData?.roles?.length > 0 && userData.roles[0] == "franchise-owner")
    ) {
      if (
        (filterContainer.start_date && filterContainer.end_date) ||
        (filterContainer.start_date == "" && filterContainer.end_date == "")
      ) {
        dispatch(
          getAllSitesData(
            filterContainer,
            userData.roles[0] == "franchise-owner" ? userData?.franchise_id : ""
          )
        );
      }
    }
    // dispatch(fetchPermission());
  }, [filterContainer]);

  useEffect(() => {
    // dispatch(fetchDashboardFeed());
    if (
      (userData?.roles?.length > 0 &&
        userData.roles[0] !== "super-admin" &&
        filterFillRate?.franchise_id?.length > 0) ||
      (userData?.roles?.length > 0 && userData.roles[0] == "super-admin") ||
      (userData?.roles?.length > 0 && userData.roles[0] == "visitor") ||
      (userData?.roles?.length > 0 && userData.roles[0] == "super-agent") ||
      (userData?.roles?.length > 0 && userData.roles[0] == "franchise-owner")
    ) {
      if (
        (filterFillRate.start_date && filterFillRate.end_date) ||
        (filterFillRate.start_date == "" && filterFillRate.end_date == "")
      ) {
        dispatch(
          getFillRateData(
            filterFillRate,
            userData.roles[0] == "franchise-owner" ? userData?.franchise_id : ""
          )
        );
      }
    }
    // dispatch(fetchPermission());
  }, [filterFillRate]);
  const DataSection = ({ title, data }) => {
    return (
      <>
        {Object.entries(data ? data : {}).map(([key, value]) => (
          <div className=" col-md-6 col-lg-2 col-xl-2 col-xxl-2  mb-4">
            <div
              className="card card-custom card-stretch gutter-b bg-light-gry backGround"
              style={{ marginBottom: "0px", height: "106px" }}
            >
              <div className="card-body">
                {/* <h3 className="text-center">{title}</h3> */}

                <div className="ratio text-dark-75">
                  <div className="item" key={key}>
                    {Number(value).toLocaleString("en-US", {
                      maximumFractionDigits: 2,
                    })}
                  </div>
                </div>
                <div className="percent"></div>
              </div>
            </div>

            <div className="text-center" style={{ margin: "5px" }}>
              {formatKey(key)}
            </div>
          </div>
        ))}
      </>
    );
  };
  const handleCheckboxChange = (e, id) => {
    e.persist(); // Prevent React from reusing the event object
    setFilter((prevFilter) => {
      const { franchise_id } = prevFilter;
      if (e.target.checked) {
        // Add id to franchise_id if it's checked
        return { ...prevFilter, franchise_id: [...franchise_id, id] };
      } else {
        // Remove id from franchise_id if it's unchecked
        return {
          ...prevFilter,
          franchise_id: franchise_id.filter((item) => item !== id),
        };
      }
    });
    setFilterFillRate((prevFilter) => {
      const { franchise_id } = prevFilter;
      if (e.target.checked) {
        // Add id to franchise_id if it's checked
        return { ...prevFilter, franchise_id: [...franchise_id, id] };
      } else {
        // Remove id from franchise_id if it's unchecked
        return {
          ...prevFilter,
          franchise_id: franchise_id.filter((item) => item !== id),
        };
      }
    });
  };

  // Extract and validate fill rate data with proper error handling
  const extractFillRateData = () => {
    try {
      if (!dashboardFillRateState || typeof dashboardFillRateState !== "object") {
        return { headers: {}, fillRates: [] };
      }

      const headers = dashboardFillRateState?.headers || {};
      const fillRates = Array.isArray(dashboardFillRateState?.fill_rates)
        ? dashboardFillRateState.fill_rates
        : [];

      if (typeof headers !== "object" || Array.isArray(headers)) {
        return { headers: {}, fillRates };
      }

      return { headers, fillRates };
    } catch (error) {
      return { headers: {}, fillRates: [] };
    }
  };

  const { headers: fillRateHeaders, fillRates: dashboardFillRate } = extractFillRateData();

  const dynamicHeaders = React.useMemo(() => {
    try {
      const keys = Object.keys(fillRateHeaders || {});
      return Array.isArray(keys) ? keys : [];
    } catch (error) {
      return [];
    }
  }, [fillRateHeaders]);

  const totals = React.useMemo(() => {
    try {
      if (!Array.isArray(dashboardFillRate) || dynamicHeaders.length === 0) {
        return {};
      }

      return dynamicHeaders.reduce((acc, headerKey) => {
        if (typeof headerKey !== "string") {
          return acc;
        }

        const sum = dashboardFillRate.reduce((sum, item) => {
          const value = item?.[headerKey];
          const numValue = Number(value) || 0;
          return sum + (isFinite(numValue) ? numValue : 0);
        }, 0);

        acc[headerKey] = isFinite(sum) ? sum : 0;
        return acc;
      }, {});
    } catch (error) {
      return {};
    }
  }, [dashboardFillRate, dynamicHeaders]);
  
  return (
    <>
      {(loading || loadingContainer || loadingPod) && <LoadingCustome />}
      {/* {permission?.dashboard?.view ? ( */}
      <>
        <div className="d-flex align-items-baseline justify-content-between ">
          <div>
            {/* <h5 className="text-dark font-weight-bold my-2 mr-5">
              <>
                {user?.first_name
                  ? user.first_name.charAt(0).toUpperCase() +
                    user.first_name.slice(1)
                  : "Andrew"}
              </>
            </h5> */}
          </div>
        </div>
        <div></div>
        <div className="mb-5 mt-5">
          {role && role?.length && role[0] === "super-admin" || role?.length && role[0] === "visitor" && (
            <div
              className="row orderTableCard align-items-center p-2 flex-wrap"
              style={{ fontSize: "13px", lineHeight: "1.4", marginBottom: "18px" }}
            >
            
              {/* Today */}
              <div className="col-xl-auto col-lg-2 col-md-4 d-flex mb-1">
                Today:&nbsp;
                <strong>
                  {(statsData?.today_confirmed + statsData?.today_cancelled)}
                  -
                  <span style={{ color: "white" }}>{statsData?.today_cancelled}</span>
                  =
                  {statsData?.today_confirmed}
                </strong>
              </div>
            
              {/* Yesterday */}
              <div className="col-xl-auto col-lg-2 col-md-4 d-flex mb-1">
                Yesterday:&nbsp;
                <strong>
                  {(statsData?.yesterday_confirmed + statsData?.yesterday_cancelled)}
                  -
                  <span style={{ color: "white" }}>{statsData?.yesterday_cancelled}</span>
                  =
                  {statsData?.yesterday_confirmed}
                </strong>
              </div>
            
              {/* DUS */}
              <div className="col-xl-auto col-lg-2 col-md-4 d-flex mb-1">
                DUS:&nbsp;
                <strong>
                  {(statsData?.dus_confirmed + statsData?.dus_cancelled)}
                  -
                  <span style={{ color: "white" }}>{statsData?.dus_cancelled}</span>
                  =
                  {statsData?.dus_confirmed}
                </strong>
              </div>
            
              {/* CS */}
              <div className="col-xl-auto col-lg-2 col-md-4 d-flex mb-1">
                CS:&nbsp;
                <strong>
                  {(statsData?.cs_confirmed + statsData?.cs_cancelled)}
                  -
                  <span style={{ color: "white" }}>{statsData?.cs_cancelled}</span>
                  =
                  {statsData?.cs_confirmed}
                </strong>
              </div>
            
              {/* DS */}
              <div className="col-xl-auto col-lg-2 col-md-4 d-flex mb-1">
                DS:&nbsp;
                <strong>
                  {(statsData?.ds_confirmed + statsData?.ds_cancelled)}
                  -
                  <span style={{ color: "white" }}>{statsData?.ds_cancelled}</span>
                  =
                  {statsData?.ds_confirmed}
                </strong>
              </div>
            
              {/* Online Today */}
              <div className="col-xl-auto col-lg-3 col-md-6 d-flex mb-1">
                Online&nbsp;Today:&nbsp;
                <strong>
                  {(statsData?.online_today_confirmed + statsData?.online_today_cancelled)}
                  -
                  <span style={{ color: "white" }}>{statsData?.online_today_cancelled}</span>
                  =
                  {statsData?.online_today_confirmed}
                </strong>
              </div>
            
              {/* Online This Month */}
              <div className="col-xl-auto col-lg-3 col-md-6 d-flex mb-1">
                Online&nbsp;This&nbsp;Month:&nbsp;
                <strong>
                  {(statsData?.online_this_month_confirmed + statsData?.online_this_month_cancelled)}
                  -
                  <span style={{ color: "white" }}>{statsData?.online_this_month_cancelled}</span>
                  =
                  {statsData?.online_this_month_confirmed}
                </strong>
              </div>
            
              {/* This Month */}
              <div className="col-xl-auto col-lg-3 col-md-6 d-flex mb-1">
                This&nbsp;Month:&nbsp;
                <strong>
                  {(statsData?.this_month_confirmed + statsData?.this_month_cancelled)}
                  -
                  <span style={{ color: "white" }}>{statsData?.this_month_cancelled}</span>
                  =
                  {statsData?.this_month_confirmed}
                </strong>
              </div>
            
              {/* Last Month */}
              <div className="col-xl-auto col-lg-3 col-md-6 d-flex mb-1">
                Last&nbsp;Month:&nbsp;
                <strong>
                  {(statsData?.last_month_confirmed + statsData?.last_month_cancelled)}
                  -
                  <span style={{ color: "white" }}>{statsData?.last_month_cancelled}</span>
                  =
                  {statsData?.last_month_confirmed}
                </strong>
              </div>
            
              {/* Forecast */}
              <div className="col-xl-auto col-lg-2 col-md-6 d-flex mb-1">
                Forecast:&nbsp;
                <strong>{statsData?.forecast}</strong>
              </div>
            
              {/* Cancel % This Month */}
              <div className="col-xl-auto col-lg-2 col-md-6 d-flex mb-1">
                Cancel % This Month:&nbsp;
                <strong>{statsData?.this_month_cancel_percentage}%</strong>
              </div>
            
              {/* Cancel % Last Month */}
              <div className="col-xl-auto col-lg-2 col-md-6 d-flex mb-1">
                Cancel % Last Month:&nbsp;
                <strong>{statsData?.last_month_cancel_percentage}%</strong>
              </div>
            
              {/* Time Since Last Order */}
              <div className="col-xl-auto col-lg-3 col-md-12 d-flex justify-content-between align-items-center mb-1">
                <span>
                  Time&nbsp;Since&nbsp;Last&nbsp;Order:&nbsp;
                  <strong>{statsData?.elapsed_time || "-"}</strong>
                </span>
                &nbsp;&nbsp;
                <div
                  onClick={handleRefreshClick}
                  style={{ cursor: "pointer", marginTop: "-2px" }}
                >
                  <RefreshIcon
                    className={`${statsData?.loading ? classes.refreshIcon : ""}`}
                  />
                </div>
              </div>
            
            </div>
          )}
        </div>
        {(userData?.roles?.length > 0 && userData.roles[0] == "super-admin" || userData.roles[0] == "visitor") ||
        admin?.user?.franchise_plan_types?.some((e) => e === "pod") ? (
          <Paper>
            <div style={{ padding: "2%", marginBottom: "2%" }}>
              <div>
                <h1 style={{ margin: "2% 0 0 1%" }}>Pod Standings</h1>
                <div className="row">
                  <div className="col-lg-8 mb-5 mt-5">
                    <div className="col-lg-8  d-flex order-flt mb-4">
                      <span className="mt-3" style={{ width: "50%" }}>
                        {filterPod?.start_date ? "Date" : "Current Month"}
                        :&nbsp;
                      </span>{" "}
                      &nbsp;
                      <InputGroup className="calendr">
                        <DatePicker
                          fullWidth
                          fixedHeight
                          className="form-control"
                          wrapperClassName="datepicker"
                          dateFormat="dd-MM-yyyy"
                          placeholderText="From Date"
                          selected={Date.parse(filterPod?.start_date)}
                          startDate={Date.parse(filterPod?.start_date)}
                          endDate={Date.parse(filterPod?.end_date)}
                          // selectsRange
                          // isClearable
                          onChange={(dates) => {
                            // const [start, end] = dates;
                            setFilterPod({
                              ...filterPod,
                              start_date: dates
                                ? moment(dates).format("yyyy-MM-DD")
                                : "",
                            });

                            // if (dates === null) {
                            //   handleSubmit();
                            // }
                            // setFieldValue(
                            //   "to_date",
                            //   end ? moment(end).format("yyyy-MM-DD") : ""
                            // );
                            // if (end || (start === null && end === null)) {
                            //   handleSubmit();
                            // }
                          }}
                        />

                        <CalendarTodayIcon />
                      </InputGroup>
                      &nbsp;
                      <InputGroup className="calendr">
                        <DatePicker
                          fullWidth
                          fixedHeight
                          className="form-control"
                          wrapperClassName="datepicker"
                          dateFormat="dd-MM-yyyy"
                          placeholderText="To Date"
                          selected={Date.parse(filterPod?.end_date)}
                          startDate={Date.parse(filterPod?.start_date)}
                          endDate={Date.parse(filterPod?.end_date)}
                          minDate={Date.parse(filterPod?.start_date)}
                          // selectsRange
                          onChange={(dates) => {
                            setFilterPod({
                              ...filterPod,
                              end_date: dates
                                ? moment(dates).format("yyyy-MM-DD")
                                : "",
                            });
                          }}
                        />

                        <CalendarTodayIcon />
                      </InputGroup>
                    </div>
                  </div>
                </div>
              </div>
              <TableContainer>
                <Table className={classes.table} aria-label="customized table">
                  <TableHead style={{ backgroundColor: "#175c83" }}>
                    <TableRow style={{ backgroundColor: "#ffe6cc" }}>
                      <StyledTableCell
                        align="center"
                        style={{ padding: "12px 0 12px" }}
                      >
                        <h4 style={{ fontSize: "15px" }}>Position</h4>
                      </StyledTableCell>
                      <StyledTableCell
                        align="center"
                        style={{ padding: "12px 0 12px" }}
                      >
                        <h4 style={{ fontSize: "15px" }}>Franchise</h4>
                      </StyledTableCell>
                      <StyledTableCell
                        align="center"
                        style={{ padding: "12px 0 12px" }}
                      >
                        <h4 style={{ fontSize: "15px" }}>Collect & Store</h4>
                        <p style={{ fontSize: "13px", marginBottom: "0" }}>
                          Pod per week(&pound;) inc VAT
                        </p>
                      </StyledTableCell>
                      <StyledTableCell
                        align="center"
                        style={{ padding: "12px 0 12px" }}
                      >
                        <h4 style={{ fontSize: "15px" }}>Drop & Store</h4>
                        <p style={{ fontSize: "13px", marginBottom: "0" }}>
                          Pod per week(&pound;) inc VAT
                        </p>
                      </StyledTableCell>
                    
                      <StyledTableCell
                        align="center"
                        style={{ padding: "12px 0 12px" }}
                      >
                        <h4 style={{ fontSize: "15px" }}>Total</h4>
                      </StyledTableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {dashboardPod?.length > 0 &&
                      dashboardPod.map((e, index) => (
                        <StyledTableRow key={index}>
                          <StyledTableCell
                            component="th"
                            scope="row"
                            align="center"
                          >
                            {e?.Position}
                          </StyledTableCell>
                            
                            <StyledTableCell align="center">
                              {e?.Franchise}
                            </StyledTableCell>

                            <StyledTableCell align="center">
                              {e?.Collect_Store}
                              <br />
                              {e?.Collect_Price}
                            </StyledTableCell>

                            <StyledTableCell align="center">
                              {e?.Drop_Store}
                              <br />
                              {e?.Drop_Price}
                            </StyledTableCell>
                            
                            <StyledTableCell align="center">
                              {e?.Total}
                            </StyledTableCell>

                        </StyledTableRow>
                      ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </div>
          </Paper>
        ) : (
          ""
        )}
        {(userData?.roles?.length > 0 && userData.roles[0] == "super-admin" || userData.roles[0] == "visitor") || 
        admin?.user?.franchise_plan_types?.some((e) => e === "container") ? (
          <Paper>
            <div style={{ padding: "2%", marginBottom: "2%" }}>
              <div>
                <h1 style={{ margin: "2% 0 0 1%" }}>
                  Container Standings
                  <br />
                  <span style={{ fontSize: "14px" }}>
                    By the number of orders. Does not include cancelled orders
                  </span>
                  <br />
                  <span style={{ fontSize: "14px", color: "red" }}>
                    All prices below are inc VAT and after 50% discount
                  </span>
                </h1>
                <div className="row">
                  <div className="col-lg-8 mb-5 mt-5">
                    <div className="col-lg-8  d-flex order-flt mb-4">
                      <span className="mt-3" style={{ width: "50%" }}>
                        {filterContainer?.start_date ? "Date" : "Current Month"}
                        :&nbsp;
                      </span>{" "}
                      &nbsp;
                      <InputGroup className="calendr">
                        <DatePicker
                          fullWidth
                          fixedHeight
                          className="form-control"
                          wrapperClassName="datepicker"
                          dateFormat="dd-MM-yyyy"
                          placeholderText="From Date"
                          selected={Date.parse(filterContainer?.start_date)}
                          startDate={Date.parse(filterContainer?.start_date)}
                          endDate={Date.parse(filterContainer?.end_date)}
                          // selectsRange
                          // isClearable
                          onChange={(dates) => {
                            // const [start, end] = dates;
                            setFilterContainer({
                              ...filterContainer,
                              start_date: dates
                                ? moment(dates).format("yyyy-MM-DD")
                                : "",
                            });

                            // if (dates === null) {
                            //   handleSubmit();
                            // }
                            // setFieldValue(
                            //   "to_date",
                            //   end ? moment(end).format("yyyy-MM-DD") : ""
                            // );
                            // if (end || (start === null && end === null)) {
                            //   handleSubmit();
                            // }
                          }}
                        />

                        <CalendarTodayIcon />
                      </InputGroup>
                      &nbsp;
                      <InputGroup className="calendr">
                        <DatePicker
                          fullWidth
                          fixedHeight
                          className="form-control"
                          wrapperClassName="datepicker"
                          dateFormat="dd-MM-yyyy"
                          placeholderText="To Date"
                          selected={Date.parse(filterContainer?.end_date)}
                          startDate={Date.parse(filterContainer?.start_date)}
                          endDate={Date.parse(filterContainer?.end_date)}
                          minDate={Date.parse(filterContainer?.start_date)}
                          // selectsRange
                          onChange={(dates) => {
                            setFilterContainer({
                              ...filterContainer,
                              end_date: dates
                                ? moment(dates).format("yyyy-MM-DD")
                                : "",
                            });
                          }}
                        />

                        <CalendarTodayIcon />
                      </InputGroup>
                    </div>
                  </div>
                </div>
              </div>
              <TableContainer>
                <Table className={classes.table} aria-label="customized table">
                  <TableHead style={{ backgroundColor: "#175c83" }}>
                    <TableRow style={{ backgroundColor: "#ffe6cc" }}>
                      <StyledTableCell
                        align="center"
                        style={{ padding: "12px 0 12px" }}
                      >
                        <h4 style={{ fontSize: "15px" }}>Position</h4>
                      </StyledTableCell>
                      <StyledTableCell
                        align="center"
                        style={{ padding: "12px 0 12px" }}
                      >
                        <h4 style={{ fontSize: "15px" }}>Franchise</h4>
                      </StyledTableCell>
                      <StyledTableCell
                        align="center"
                        style={{ padding: "12px 0 12px" }}
                      >
                        <h4 style={{ fontSize: "15px" }}>Site</h4>
                      </StyledTableCell>
                      <StyledTableCell
                        align="center"
                        style={{ padding: "12px 0 12px" }}
                      >
                        <h4 style={{ fontSize: "15px" }}>20ft</h4>
                        <p style={{ fontSize: "13px", marginBottom: "0" }}>
                          (£ INC VAT)
                        </p>
                      </StyledTableCell>
                      <StyledTableCell
                        align="center"
                        style={{ padding: "12px 0 12px" }}
                      >
                        <h4 style={{ fontSize: "15px" }}>8ft</h4>
                        <p style={{ fontSize: "13px", marginBottom: "0" }}>
                          (£ INC VAT)
                        </p>
                      </StyledTableCell>
                      <StyledTableCell
                        align="center"
                        style={{ padding: "12px 0 12px" }}
                      >
                        <h4 style={{ fontSize: "15px" }}>6ft</h4>
                        <p style={{ fontSize: "13px", marginBottom: "0" }}>
                          (£ INC VAT)
                        </p>
                      </StyledTableCell>
                      <StyledTableCell
                        align="center"
                        style={{ padding: "12px 0 12px" }}
                      >
                        <h4 style={{ fontSize: "15px" }}>5ft</h4>
                        <p style={{ fontSize: "13px", marginBottom: "0" }}>
                          (£ INC VAT)
                        </p>
                      </StyledTableCell>
                      <StyledTableCell
                        align="center"
                        style={{ padding: "12px 0 12px" }}
                      >
                        <h4 style={{ fontSize: "15px" }}>Car Park</h4>
                        <p style={{ fontSize: "13px", marginBottom: "0" }}>
                          (£ INC VAT)
                        </p>
                      </StyledTableCell>
                      <StyledTableCell
                        align="center"
                        style={{ padding: "12px 0 12px" }}
                      >
                        <h4 style={{ fontSize: "15px" }}>Room</h4>
                        <p style={{ fontSize: "13px", marginBottom: "0" }}>
                          (£ INC VAT)
                        </p>
                      </StyledTableCell>
                      <StyledTableCell
                        align="center"
                        style={{ padding: "12px 0 12px" }}
                      >
                        <h4 style={{ fontSize: "15px" }}>Total</h4>
                      </StyledTableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {dashboardContainer?.length > 0 &&
                      dashboardContainer.map((e, index) => (
                        <StyledTableRow key={index}>
                          <StyledTableCell
                            component="th"
                            scope="row"
                            align="center"
                          >
                            {e?.Position}
                          </StyledTableCell>
                          <StyledTableCell align="center">
                            {e?.Franchise}
                          </StyledTableCell>
                          <StyledTableCell align="center">
                            {e?.SiteName}
                          </StyledTableCell>
                          <StyledTableCell align="center">
                            {e?._20ft}
                            <br />
                            {e?.price_20ft}
                          </StyledTableCell>
                          <StyledTableCell align="center">
                            {e?._8ft}
                            <br />
                            {e?.price_8ft}
                          </StyledTableCell>
                          <StyledTableCell align="center">
                            {e?._6ft}
                            <br />
                            {e?.price_6ft}
                          </StyledTableCell>
                          <StyledTableCell align="center">
                            {e?._5ft}
                            <br />
                            {e?.price_5ft}
                          </StyledTableCell>
                          <StyledTableCell align="center">
                            {e?._car}
                            <br />
                            {e?.price_car}
                          </StyledTableCell>
                          <StyledTableCell align="center">
                            {e?._room}
                            <br />
                            {e?.price_room}
                          </StyledTableCell>
                          <StyledTableCell align="center">
                            {e?.Order_Count}
                          </StyledTableCell>
                        </StyledTableRow>
                      ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </div>
          </Paper>
        ) : (
          ""
        )}
        <Paper>
          <div style={{ padding: "2%", marginBottom: "2%" }}>
            <div>
              <h1 style={{ margin: "2% 0 0 1%" }}>
                Fill Rate{" "}
                <span style={{ fontSize: "14px" }}>
                  (based on Move In marked Completed on Vault. If Move In not
                  marked Completed on Vault, then the data would not show up in
                  the table below) BETA
                </span>
              </h1>
              <div className="row">
                <div className="col-lg-8 mb-5 mt-5">
                  {/* <div className="col-lg-8  d-flex order-flt mb-4">
                    <span className="mt-3" style={{ width: "50%" }}>

                      {filterContainer?.start_date ? "Date" : "Current Month"}:&nbsp;
                    </span>{" "}
                    &nbsp;
                    <InputGroup className="calendr">
                      <DatePicker
                        fullWidth
                        fixedHeight
                        className="form-control"
                        wrapperClassName="datepicker"
                        dateFormat="dd-MM-yyyy"
                        placeholderText="From Date"
                        selected={Date.parse(filterContainer?.start_date)}
                        startDate={Date.parse(filterContainer?.start_date)}
                        endDate={Date.parse(filterContainer?.end_date)}
                        // selectsRange
                        // isClearable
                        onChange={(dates) => {
                          // const [start, end] = dates;
                          setFilterContainer(
                            {
                              ...filterContainer, "start_date":
                                dates ? moment(dates).format("yyyy-MM-DD") : ""
                            }
                          );

                          // if (dates === null) {
                          //   handleSubmit();
                          // }
                          // setFieldValue(
                          //   "to_date",
                          //   end ? moment(end).format("yyyy-MM-DD") : ""
                          // );
                          // if (end || (start === null && end === null)) {
                          //   handleSubmit();
                          // }
                        }}
                      />

                      <CalendarTodayIcon />
                    </InputGroup>
                    &nbsp;
                    <InputGroup className="calendr">

                      <DatePicker
                        fullWidth
                        fixedHeight
                        className="form-control"
                        wrapperClassName="datepicker"
                        dateFormat="dd-MM-yyyy"
                        placeholderText="To Date"
                        selected={Date.parse(filterContainer?.end_date)}
                        startDate={Date.parse(filterContainer?.start_date)}
                        endDate={Date.parse(filterContainer?.end_date)}
                        minDate={Date.parse(filterContainer?.start_date)}
                        // selectsRange
                        onChange={(dates) => {
                          setFilterContainer(
                            {
                              ...filterContainer, "end_date":
                                dates ? moment(dates).format("yyyy-MM-DD") : ""
                            }
                          );
                        }}
                      />

                      <CalendarTodayIcon />
                    </InputGroup>
                  </div> */}
                </div>
              </div>
            </div>
            <TableContainer>
              <Table className={classes.table} aria-label="customized table">
                <TableHead style={{ backgroundColor: "#175c83" }}>
                  <TableRow style={{ backgroundColor: "#ffe6cc" }}>
                    <StyledTableCell
                      align="center"
                      style={{ padding: "12px 0 12px" }}
                    >
                      <h4 style={{ fontSize: "15px", marginBottom: "0px" }}>Franchise</h4>
                    </StyledTableCell>
                    <StyledTableCell
                      align="center"
                      style={{ padding: "12px 0 12px" }}
                    >
                      <h4 style={{ fontSize: "15px", marginBottom: "0px" }}>Site</h4>
                    </StyledTableCell>
                    {dynamicHeaders && dynamicHeaders.length > 0 ? (
                      dynamicHeaders.map((headerKey) => {
                        try {
                          const displayName =
                            fillRateHeaders[headerKey] || headerKey;
                          return (
                            <StyledTableCell
                              key={`header-${headerKey}`}
                              align="center"
                              style={{ padding: "12px 0 12px" }}
                            >
                              <h4 style={{ fontSize: "15px", marginBottom: "0px" }}>
                                {displayName}
                              </h4>
                            </StyledTableCell>
                          );
                        } catch (error) {
                          return null;
                        }
                      })
                    ) : (
                      <StyledTableCell align="center" colSpan={2}>
                        <p style={{ fontSize: "14px", color: "#999" }}>
                          No data available
                        </p>
                      </StyledTableCell>
                    )}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {dashboardFillRate && dashboardFillRate.length > 0 ? (
                    <>
                      {dashboardFillRate.map((row, index) => {
                        try {
                          const franchise =
                            row?.Franchise || row?.franchise || "N/A";
                          const siteName =
                            row?.SiteName || row?.site_name || "N/A";

                          return (
                            <StyledTableRow key={`row-${index}`}>
                              <StyledTableCell
                                component="th"
                                scope="row"
                                align="center"
                              >
                                {franchise}
                              </StyledTableCell>
                              <StyledTableCell align="center">
                                {siteName}
                              </StyledTableCell>
                              {dynamicHeaders.map((headerKey) => {
                                try {
                                  const value = row?.[headerKey];
                                  const numValue = Number(value) || 0;
                                  return (
                                    <StyledTableCell
                                      key={`cell-${index}-${headerKey}`}
                                      align="center"
                                    >
                                      {isFinite(numValue) ? numValue : 0}
                                    </StyledTableCell>
                                  );
                                } catch (error) {
                                  return (
                                    <StyledTableCell
                                      key={`cell-${index}-${headerKey}`}
                                      align="center"
                                    >
                                      -
                                    </StyledTableCell>
                                  );
                                }
                              })}
                            </StyledTableRow>
                          );
                        } catch (error) {
                          return null;
                        }
                      })}
                      {dynamicHeaders && dynamicHeaders.length > 0 && (
                        <StyledTableRow>
                          <StyledTableCell align="center">
                            <strong>Total</strong>
                          </StyledTableCell>
                          <StyledTableCell align="center"></StyledTableCell>
                          {dynamicHeaders.map((headerKey) => {
                            try {
                              const totalValue = totals[headerKey] || 0;
                              return (
                                <StyledTableCell
                                  key={`total-${headerKey}`}
                                  align="center"
                                >
                                  <strong>
                                    {isFinite(totalValue) ? totalValue : 0}
                                  </strong>
                                </StyledTableCell>
                              );
                            } catch (error) {
                              return (
                                <StyledTableCell
                                  key={`total-${headerKey}`}
                                  align="center"
                                >
                                  <strong>-</strong>
                                </StyledTableCell>
                              );
                            }
                          })}
                        </StyledTableRow>
                      )}
                    </>
                  ) : (
                    <StyledTableRow>
                      <StyledTableCell
                        align="center"
                        colSpan={dynamicHeaders.length + 2}
                        style={{ padding: "20px" }}
                      >
                        <p style={{ fontSize: "14px", color: "#999" }}>
                          No fill rate data available
                        </p>
                      </StyledTableCell>
                    </StyledTableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        </Paper>
        <div className="row">
          <div className="col-lg-12 col-xxl-12 grown-card">
            <div className="card card-custom  card-stretch gutter-b">
              <div className="card-body ">
                <div className="row">
                  <div className="col-lg-8 mb-5 mt-5">
                    <div className="col-lg-8  d-flex order-flt mb-4">
                      <span className="mt-3">
                        Created&nbsp;By&nbsp;Date:&nbsp;
                      </span>{" "}
                      &nbsp;
                      <InputGroup className="calendr">
                        <DatePicker
                          fullWidth
                          fixedHeight
                          className="form-control"
                          wrapperClassName="datepicker"
                          dateFormat="dd-MM-yyyy"
                          placeholderText="From Date"
                          selected={Date.parse(filter?.start_date)}
                          startDate={Date.parse(filter?.start_date)}
                          endDate={Date.parse(filter?.end_date)}
                          // selectsRange
                          // isClearable
                          onChange={(dates) => {
                            // const [start, end] = dates;
                            setFilter({
                              ...filter,
                              start_date: dates
                                ? moment(dates).format("yyyy-MM-DD")
                                : "",
                            });

                            // if (dates === null) {
                            //   handleSubmit();
                            // }
                            // setFieldValue(
                            //   "to_date",
                            //   end ? moment(end).format("yyyy-MM-DD") : ""
                            // );
                            // if (end || (start === null && end === null)) {
                            //   handleSubmit();
                            // }
                          }}
                        />

                        <CalendarTodayIcon />
                      </InputGroup>
                      &nbsp;
                      <InputGroup className="calendr">
                        <DatePicker
                          fullWidth
                          fixedHeight
                          className="form-control"
                          wrapperClassName="datepicker"
                          dateFormat="dd-MM-yyyy"
                          placeholderText="To Date"
                          selected={Date.parse(filter?.end_date)}
                          startDate={Date.parse(filter?.start_date)}
                          endDate={Date.parse(filter?.end_date)}
                          minDate={Date.parse(filter?.start_date)}
                          // selectsRange
                          onChange={(dates) => {
                            setFilter({
                              ...filter,
                              end_date: dates
                                ? moment(dates).format("yyyy-MM-DD")
                                : "",
                            });
                          }}
                        />

                        <CalendarTodayIcon />
                      </InputGroup>
                    </div>
                  </div>

                  {userData?.roles?.length > 0 &&
                    userData.roles[0] === "super-admin" && (
                      <div
                        className="col-lg-4 mb-5 mt-5 order-flt"
                        style={{ justifyContent: "end" }}
                      >
                        <div
                          className="loader-dropdown"
                          style={{ width: "70%" }}
                        >
                          <Dropdown
                            className="dropdown-inline doggle-toggle-dashboard"
                            drop="down"
                            alignRight
                          >
                            <Dropdown.Toggle
                              id="dropdown-toggle-top2"
                              variant="transparent"
                              className="btn btn-light   dropdown-toggle text-dark-75 "
                              title={""}
                            >
                              Franchise
                            </Dropdown.Toggle>
                            <Dropdown.Menu className="dropdown-menu dropdown-menu-sm dropdown-menu-right">
                              <ul className="navi navi-hover">
                                {franchises?.map((item, index) => (
                                  <li className="navi-item">
                                    <>
                                      <span className="navi-text">
                                        <label className="checkbox">
                                          <input
                                            type="checkbox"
                                            // name={`collection_loader_id[${index}]`}
                                            checked={filter.franchise_id.includes(
                                              item?.id
                                            )}
                                            onChange={(e) =>
                                              handleCheckboxChange(e, item?.id)
                                            }
                                          />
                                          <span className="mr-2"></span>{" "}
                                          {item?.name || "-"}
                                        </label>
                                      </span>
                                    </>
                                  </li>
                                )) || ""}
                              </ul>
                            </Dropdown.Menu>
                          </Dropdown>
                        </div>
                      </div>
                    )}
                </div>
                <div className="row mt-10">
                  {dashboardState && (
                    <>
                      {console.log("dashboardState", filter)}
                      {Object.entries(dashboardState)
                        .filter(([key, value]) => value !== null)
                        .map(([key, value]) => {
                          const userHasRole =
                            userData?.roles?.length > 0 &&
                            userData.roles[0] !== "super-admin";
                          const userHasFranchisePlan = userData?.franchise_plan_types?.some(
                            (e) => e === "pod"
                          );
                          const formattedKey = formatKey(key);
                          const userHasFranchiseContainer = userData?.franchise_plan_types?.some(
                            (e) => e === "container"
                          );
                          if (
                            (userHasRole &&
                              !userHasFranchisePlan &&
                              formattedKey === "POD") ||
                            (userHasRole &&
                              !userHasFranchisePlan &&
                              formattedKey === "Staticpod")
                          ) {
                            return null; // Skip rendering this entry
                          }
                          if (
                            (userHasRole &&
                              !userHasFranchiseContainer &&
                              formattedKey === "Con") ||
                            (userHasRole &&
                              !userHasFranchiseContainer &&
                              formattedKey === "Staticcon")
                          ) {
                            return null;
                          }
                          if (
                            userData?.roles?.length > 0 &&
                            userData.roles[0] !== "super-admin" &&
                            formatKey(key) === "Contact"
                          ) {
                            return null;
                          }
                          // The Box service was discontinued in July 2024, so
                          // its tile is hidden for everyone.
                          if (formatKey(key) === "Box") {
                            return null;
                          }
                          const removeWords = (str) => {
                            return str
                              .replace(/\b(Pod|Container)\b/g, "")
                              .trim();
                          };
                          const headingKey = formatKey(key);
                          const capitalizeFirstLetter = (str) => {
                            return str.charAt(0).toUpperCase() + str.slice(1);
                          };
                          const finalHeading = capitalizeFirstLetter(
                            removeWords(headingKey)
                          );
                          return (
                            <>
                              <div style={{ width: "100%" }}>
                                <h1
                                  style={{
                                    marginLeft: "2%",
                                    marginBottom: "1%",
                                    marginTop:
                                      formatKey(key) == "Container today"
                                        ? "2%"
                                        : "",
                                  }}
                                >
                                  {formatKey(key) == "Pod today"
                                    ? "Pod"
                                    : formatKey(key) == "Container today"
                                    ? "Container"
                                    : ""}
                                </h1>
                              </div>
                              <br />
                              {formatKey(key) != "Staticpod" &&
                                formatKey(key) != "Podonoff" &&
                                formatKey(key) != "Cononoff" &&
                                formatKey(key) != "Staticcon" &&
                                formatKey(key) != "Pod3rd" && (
                                  <h3 style={{ paddingLeft: "26px" }}>
                                    {finalHeading == "Today" &&
                                    (filter?.end_date !== "" ||
                                      filter?.franchise_id?.length > 0)
                                      ? ""
                                      : finalHeading}
                                  </h3>
                                )}

                              <div
                                className="row w-100"
                                style={{ paddingLeft: "26px" }}
                              >
                                <DataSection
                                  title={key}
                                  key={key}
                                  data={value}
                                />
                              </div>
                            </>
                          );
                        })}
                    </>
                  )}
                </div>
                <hr />
                {((userData?.roles?.length > 0 &&
                  userData.roles[0] == "super-admin" || userData.roles[0] == "visitor") ||
                  admin?.user?.franchise_plan_types?.some(
                    (e) => e === "container"
                  )) &&
                  dashboardConListState && (
                    <div className="row">
                      <div className="col-lg-12 col-xxl-12 grown-card">
                        {/* Legend */}
                        <div className="legend">
                          <div className="legend-item">
                            <span className="box occupied"></span> Occupied
                          </div>
                          <div className="legend-item">
                            <span className="box available"></span> Available
                          </div>
                          <div className="legend-item">
                            <span className="box maintenance"></span> Under maintenance
                          </div>
                          <div className="legend-item">
                            <span className="box capacity"></span> Capacity
                          </div>
                          <div className="legend-item">
                            <span className="box not-sold"></span> Not Sold
                          </div>
                        </div>
                      </div>

                      {Object.entries(dashboardConListState ?? {}).map(
                        ([siteId, site], index) => (
                          <div
                            className="col-lg-4 col-xxl-4 grown-card"
                            key={index}
                          >
                            <h4>
                              <strong>{site.name}</strong>
                            </h4>
                            {/* <BarChart key={index} oNASiteData={site.containers} /> */}

                            <div className="chart-container">
                              {/* Bars */}
                              {Object.entries(site.containers).map(
                                ([key, { capacity, available, occupied, maintenance = 0 }]) => {
                                  const segments = getContainerBarSegments({
                                    capacity,
                                    available,
                                    occupied,
                                    maintenance,
                                  });
                                  const toBarWidth = (ratio) =>
                                    ratio * TOTAL_BAR_WIDTH;
                                  const occupiedWidth = toBarWidth(
                                    segments.occupiedRatio,
                                  );
                                  const availableWidth = toBarWidth(
                                    segments.availableRatio,
                                  );
                                  const maintenanceWidth = toBarWidth(
                                    segments.maintenanceRatio,
                                  );
                                  const capacityWidth = toBarWidth(
                                    segments.capacityRatio,
                                  );
                                  const notSoldWidth = segments.isNotSold
                                    ? TOTAL_BAR_WIDTH
                                    : 0;
                                  const { remainingCapacity } = segments;

                                  return (
                                    <div key={key} className="bar-group">
                                      <div className="barLabel">
                                        {key.replace("_", " ")}
                                      </div>
                                      <div className="bar">
                                        {occupied > 0 && (
                                          <div
                                            className="occupied"
                                            style={{
                                              width: `${occupiedWidth}px`,
                                            }}
                                          ></div>
                                        )}
                                        {available > 0 && (
                                          <div
                                            className="available"
                                            style={{
                                              width: `${availableWidth}px`,
                                            }}
                                          ></div>
                                        )}
                                        {maintenance > 0 && (
                                          <div
                                            className="maintenance"
                                            style={{
                                              width: `${maintenanceWidth}px`,
                                            }}
                                          ></div>
                                        )}
                                        {capacity !== null &&
                                          remainingCapacity > 0 && (
                                            <div
                                              className="capacity"
                                              style={{
                                                width: `${capacityWidth}px`,
                                              }}
                                            ></div>
                                          )}
                                        {capacity === null && (
                                          <div
                                            className="not-sold"
                                            style={{
                                              width: `${notSoldWidth}px`,
                                            }}
                                          ></div>
                                        )}
                                      </div>
                                      <div className="values w-100">
                                        {occupied > 0 && (
                                          <span
                                            className="occupiedT"
                                            style={{
                                              width: `${occupiedWidth}px`,
                                              textAlign: "start",
                                            }}
                                          >
                                            <strong>{occupied}</strong>
                                          </span>
                                        )}
                                        {available > 0 && (
                                          <span
                                            className="availableT"
                                            style={{
                                              width: `${availableWidth}px`,
                                              textAlign: "center",
                                            }}
                                          >
                                            <strong>{available}</strong>
                                          </span>
                                        )}
                                        {maintenance > 0 && (
                                          <span
                                            className="maintenanceT"
                                            style={{
                                              width: `${maintenanceWidth}px`,
                                              textAlign: "center",
                                            }}
                                          >
                                            <strong>{maintenance}</strong>
                                          </span>
                                        )}
                                        {capacity !== null &&
                                          remainingCapacity > 0 && (
                                            <span
                                              className="capacityT"
                                              style={{
                                                width: `${capacityWidth}px`,
                                                textAlign: "end",
                                              }}
                                            >
                                              <strong> {capacity}</strong>
                                            </span>
                                          )}
                                        {capacity === null && (
                                          <span
                                            style={{
                                              width: `${notSoldWidth}px`,
                                              textAlign: "center",
                                            }}
                                          >
                                            Not&nbsp;Sold
                                          </span>
                                        )}
                                      </div>
                                    </div>
                                  );
                                }
                              )}
                            </div>
                          </div>
                        )
                      )}
                    </div>
                  )}
              </div>
            </div>
          </div>
        </div>
      </>
      {/* ) : (
        <Card>
          <CardBody>
            <NotAuthorized />
          </CardBody>
        </Card>
      )} */}
    </>
  );
}
